import { Outlet } from 'react-router-dom'

import { ContractsEmployeesContractVersionFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import { useContractVersionsPayrollPolicies } from 'modules/contracts/store/collections/contractVersionsPayrollPolicies'
import { usePolicies } from 'modules/payroll_bundle/store/collections/policies'

interface BodyProps {
  employeeId: string
  graphqlContractVersion?: ContractsEmployeesContractVersionFragment | null
  graphqlContractVersions?: ContractsEmployeesContractVersionFragment[]
}

const Body = ({ employeeId, graphqlContractVersion, graphqlContractVersions }: BodyProps) => {
  const policies = usePolicies()
  const contractVersionsPayrollPolicies = useContractVersionsPayrollPolicies()
  const contractVersionId = graphqlContractVersion?.id

  const { loading: loadingContractVersionsPayrollPolicies } = useAsyncData(() => {
    if (!contractVersionId) {
      return Promise.resolve()
    }

    return contractVersionsPayrollPolicies.fetch({
      data: {
        contract_version_ids: [contractVersionId],
      },
    })
  }, [contractVersionId])

  const { loading: loadingPolicies } = useAsyncData(() => {
    return policies.fetch({ data: { include_archived: true } })
  }, [])

  if (loadingContractVersionsPayrollPolicies || loadingPolicies) {
    return <Loading />
  }

  return <Outlet context={{ employeeId, graphqlContractVersion, graphqlContractVersions }} />
}

export default observer(Body)
